import Vue from 'vue'
import store from './store';
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { parseTime } from "@/utils/ruoyi";
import Pagination from "@/components/Pagination";
import login from "@/views/login";
Vue.component('Pagination', Pagination)
Vue.component('login', login)
Vue.prototype.parseTime = parseTime
//定义全局变量
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
}).$mount('#app')
